export const TITLE = 'date_selection.not_available_alert.title';
export const BODY = 'date_selection.not_available_alert.body';
export const BUTTON = 'date_selection.not_available_alert.button';
